














































import Vue from 'vue';
import { mapActions } from 'vuex';
import Config from '../../../../configuration';

import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    methods: {
        ...mapActions('bh-items', { createNewItem: 'create', patchItem: 'patch' })
    },
    components: {
        
    }
})
export default class QuestListsTable extends Vue {
    @Prop({ default() { return null; } })
    item!: any;

    @Prop({ default: null })
    type!: string;

    @Prop({ default: null })
    routin!: string;

    dialogAdd = false;
    dialogLoading = false;

    createNewItem: any;
    patchItem: any;

    form = {
        name: this.item ? this.item.name : null,
        description: this.item ? this.item.description : null,
        icon_image: this.item ? this.item.icon : null,
        image: this.item ? this.item.badge : null,
        type: this.item ? this.item.type : null,
        meta_data: this.item ? this.item.meta_data : null,
    };

    public valueComparison(a: any, b: any) {
        return a === b;
    }

    @Watch('dialogAdd')
    ResetForm(nv: boolean) {
        if(nv && this.item === null) {
            this.form = {
                name: this.item ? this.item.name : null,
                description: this.item ? this.item.description : null,
                icon_image: this.item ? this.item.icon : null,
                image: this.item ? this.item.badge : null,
                type: this.item ? this.item.type : null,
                meta_data: this.item ? this.item.meta_data : null
            };
        }
    }

    public async submit() {
        this.dialogLoading = true;
        try {
            const formResult = Object.assign({}, this.form);
            
            if(!formResult.name || !formResult.description) {
                throw new Error('Please complete the form!');
            }

            if(!(formResult.image instanceof File) && this.item === null) {
                throw new Error('Please select image!');
            }

            if(this.item === null || (formResult.image && formResult.image instanceof File)) {
                const image = await this.toBase64(formResult.image);
                const imageS3File = await fetch(`${Config.host}/api/upload`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': window.localStorage.getItem('feathers-jwt')
                    },
                    body: JSON.stringify({
                        uri: image
                    })
                } as any).then(data => data.json());
                formResult.image = `https://api.breakinghits.com/public/${imageS3File.id}`;
            }

            if(formResult.icon_image && formResult.icon_image instanceof File) {
                const iconImage = await this.toBase64(formResult.icon_image);
                const iconImageS3File = await fetch(`${Config.host}/api/upload`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': window.localStorage.getItem('feathers-jwt')
                    },
                    body: JSON.stringify({
                        uri: iconImage
                    })
                } as any).then(data => data.json());
                formResult.icon_image = `https://api.breakinghits.com/public/${iconImageS3File.id}`;
            }

            if(this.item !== null) {
                const patchedItem = Object.keys(formResult).reduce((res: any, key: string) => {
                    const value = (formResult as any)[key];
                    if(value !== null && typeof value !== 'undefined')
                        res[key] = value;
                    return res;
                }, {});
                this.patchItem([this.item.id, patchedItem]);
            } else {
                await this.createNewItem(formResult);
            }
            this.dialogAdd = false;
            this.$emit('success');
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.dialogLoading = false;
        }
    }

    public async toBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
}
